import { render, staticRenderFns } from "./LeadCategories.vue?vue&type=template&id=5a9972ad"
import script from "./LeadCategories.vue?vue&type=script&lang=js"
export * from "./LeadCategories.vue?vue&type=script&lang=js"
import style0 from "./LeadCategories.vue?vue&type=style&index=0&id=5a9972ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports